import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  display: ['none', null, 'flex'],
  justifyContent: 'center',
};

export const TextItem: CSSObject = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'sm',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'base',
  pos: 'absolute',
  top: '355px',
  px: '10',
  span: { color: 'beta.400', fontWeight: 'bold' },
};
